module.exports = __webpack_public_path__ + "img/fire.7dc710e7.png";